import FlyDirect from "./FlyDirect.js";
import {descend, setTas} from "../planeSlice.js";
import {getVref} from "../../assets/virtual-flyout/perf-calc.js";
import {getActiveRunway, getAirportDetails} from "../../assets/virtual-flyout/airport-service.js";

const SCREEN_HEIGHT = 50;

export default class FlyFinal extends FlyDirect {
    constructor(planeId, airport) {
        super(planeId, airport);
        this.airport = airport;
    }

    logAction() {
        this.log(`Final runway ${this.runway}`);
    }

    execute() {
        const planeState = this.getState();
        this.runway = getActiveRunway(this.airport.code, planeState.wind.heading).runway;

        super.execute();
        this.dispatch(setTas({tas: getVref()}));
        const airportDetails = getAirportDetails(this.airport.code);
        this.dispatch(descend({altitude: airportDetails.elevation + SCREEN_HEIGHT}));
    }
}
